<template>
  <div
    class="ex-indicator"
    :class="indicatorBgClass"
  />
</template>

<script setup lang="ts">
interface IProps {
  color?: string
  size?: string | number
}

const props = withDefaults(defineProps<IProps>(), {
  color: 'point-color',
  size: 8,
})

const indicatorSize = computed(() => {
  return `${props.size}px`
})

const indicatorBgClass = computed(() => {
  return `bg-${props.color}`
})
</script>

<style scoped lang="scss">
.ex-indicator {
  @apply rounded-full;
  width: v-bind('indicatorSize');
  height: v-bind('indicatorSize');
}
</style>